const colors = {
  // Cores de destaque de produtos
  bloqueio: "#b9cfb5",
  lancamento: "#ecb3ff",
  promocao: "#99ccff",

  // Tabelas
  tableColors: {
    header: "#7eb9cd",
    headerText: "#223f45",
    border: "#ddd",
  },

  // Cores primárias
  primary: "#213880",
  primaryLight: "#7eb9cd",
  primaryLightHover: "#6ca9bd",
  primaryLightDisabled: "#a8d0dc",
  primaryDark: "#1a2d66",

  // Texto
  text: {
    primary: "#333",
    secondary: "#666",
    muted: "#5a5b5f",
    light: "#999",
    white: "#fff",
    dark: "#1a1a1a",
    link: "#324852",
    subtitle: "#718096",
    title: "#2d3748",
    hint: "#a0aec0",
  },

  // Backgrounds
  background: {
    main: "#fff",
    light: "#f5f5f5",
    dark: "#e0e0e0",
    hover: "#f5f7fa",
    gradient: "linear-gradient(135deg, #f5f5f5 0%, #e4e8ec 100%)",
    disabled: "#ccc",
  },

  // Estados
  success: "#0eb200",
  successHover: "#0c9a00",
  successDisabled: "#8bc985",
  successDark: "#008000",
  error: "#dc3545",
  errorLight: "#ff0000",
  errorDark: "#d32f2f",
  errorBg: "#fcc",
  errorBgLight: "#fff5f5",
  errorBorder: "#feb2b2",
  errorBorderDark: "#e53e3e",
  errorText: "#c53030",
  warning: "#ffc107",
  warningBgLight: "#fffbeb",
  warningBorder: "#fcd34d",
  warningBorderDark: "#d97706",
  warningText: "#92400e",
  info: "#17a2b8",

  // Loader
  loader: {
    primary: "#213880",
    light: "rgba(255, 255, 255, 0.5)",
    muted: "rgba(33, 56, 128, 0.5)",
  },

  // Navbar
  navbar: {
    bg: "#8cc7db",
    hover: "#81afc6",
  },

  // Footer
  footer: {
    gradient: "linear-gradient(90deg, #7eb9cd 0%, #87d1e1 50%, #7eb9cd 100%)",
  },

  // Modal
  modal: {
    headerBtn: "#afbde6",
    overlay: "rgba(0, 0, 0, 0.5)",
  },

  // Borders
  border: {
    light: "#ddd",
    medium: "#999",
    dark: "#777",
    black: "#000",
  },

  // Input
  input: {
    focus: "#7eb9cd",
    focusShadow: "rgba(126, 185, 205, 0.3)",
  },

  // Clock
  clock: {
    open: "#0f0",
    closed: "#dd0",
  },

  // Toast
  toast: {
    success: "#07bc0c",
    error: "#e74c3c",
    info: "#3498db",
    warning: "#f1c40f",
  },

  // Legenda
  legend: {
    red: "#f00",
    green: "#3f0",
  },

  // MUI Theme
  mui: {
    primary: "#3f51b5",
    secondary: "#f50057",
  },

  // Product
  product: {
    outOfStock: "#900",
  },
};

export default colors;
